<nz-header class="header" nz-flex nzAlign="center">
  <img src="assets/mathema-logo.png" alt="Mathema.me" class="logo" />
</nz-header>

@if (subheader()) {
  <nz-header class="subheader">
    @if (subheader().cmp) {
      <ng-container *ngComponentOutlet="subheader().cmp"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="subheader().tmp"></ng-container>
    }
  </nz-header>
}
